import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UiModule } from '@ov-suite/ui';
import { JournalEventsRoutes } from './journal-events.routing';
import { JournalEventsListComponent } from './list/journal-events-list.component';
import { ManualJournalModalComponent } from './manual-journal-modal/manual-journal-modal.component';

@NgModule({
  imports: [CommonModule, RouterModule.forChild(JournalEventsRoutes), FormsModule, ReactiveFormsModule, UiModule],
  declarations: [JournalEventsListComponent, ManualJournalModalComponent],
})
export class JournalEventsModule {}
